<!--================================
=            DASHBOARD1            =
=================================-->
<template>
  <v-container>
    <!-- HEADER -->
    <v-row no-gutters>
      <base-header>
        <div slot="page-header">Dashboard1</div>
      </base-header>
    </v-row>
    <!-- HEADER END-->

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12" d-flex>
        <div class="ma-3">
          <v-alert color="purple lighten-4" pl-3 pr-3>
            <v-row>
              <v-col cols="12" sm="12" md="9" d-flex>
                <div class="title black--text">Lorem Ipsum</div>
                <div class="black--text">
                  Maecenas ullamcorper, dui et placerat feugiat, eros pede varius
                  nisi, condimentum
                  viverra felis nunc et lorem. Duis vel nibh at velit scelerisque suscipit. Praesent
                  blandit laoreet nibh. Aenean posuere, tortor sed cursus feugiat, nunc augue blandit
                  nunc, eu sollicitudin urna dolor sagittis lacus. Etiam sollicitudin, ipsum eu
                  pulvinar
                  rutrum, tellus ipsum laoreet sapien, quis venenatis ante odio sit amet eros.
                </div>
              </v-col>
              <v-col cols="12" sm="12" md="3" d-flex>
                <img src="../../assets/img/dash.png" />
              </v-col>
            </v-row>
          </v-alert>
        </div>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="4" d-flex>
        <v-card class="elevation-2 pl-4 ml-5 mb-3 mr-3 pr-3" outlined>
          <v-list-item three-line>
            <v-list-item-content>
              <div class="overline mb-4">OVERLINE</div>
              <v-list-item-title class="headline mb-1">Cryptography</v-list-item-title>
            </v-list-item-content>
            <v-list-item-avatar tile class="elevation-5 purple darken-2 white--text" size="80">
              <i class="material-icons md-48">monochrome_photos</i>
            </v-list-item-avatar>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="4" d-flex>
        <v-card class="elevation-2 pl-3 ml-3 mb-3 mr-4 pr-4 accent-4" outlined>
          <v-list-item three-line>
            <v-list-item-content>
              <div class="overline mb-4">OVERLINE</div>
              <v-list-item-title class="headline mb-1">Bounce</v-list-item-title>
            </v-list-item-content>
            <v-list-item-avatar class="elevation-5 cyan darken-2 white--text" tile size="80">
              <i class="material-icons">museum</i>
            </v-list-item-avatar>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="4" d-flex>
        <v-card class="elevation-2 pl-3 ml-3 mb-3 mr-4 pr-4 accent-4" outlined>
          <v-list-item three-line>
            <v-list-item-content>
              <div class="overline mb-4">OVERLINE</div>
              <v-list-item-title class="headline mb-1">Views</v-list-item-title>
            </v-list-item-content>
            <v-list-item-avatar class="elevation-5 deep-purple white--text darken-2" tile size="80">
              <i class="material-icons">emoji_events</i>
            </v-list-item-avatar>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="4" d-flex>
        <base-card class="pa-2">
          <div slot="card-header">Analytics Overview</div>
          <div slot="card-body">
            <pie-card></pie-card>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="8" d-flex>
        <base-card class="pa-2">
          <div slot="card-header">Reactive Social</div>
          <div slot="card-body">
            <chart-lineapex></chart-lineapex>
          </div>
        </base-card>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12" d-flex>
        <analytic-sparkline></analytic-sparkline>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12" d-flex>
        <base-card class="pa-2">
          <div slot="card-header">Analytics Overview</div>
          <div slot="card-body">
            <table-browser></table-browser>
          </div>
        </base-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";
import ListFriends from "../../components/Widgets/List/ListFriends.vue";
import ListFavorite from "../../components/Widgets/List/ListFavorite.vue";
import ListMessages from "../../components/Widgets/List/ListMessages.vue";
import ListNotification from "../../components/Widgets/List/ListFriends.vue";
import ListLove from "../../components/Widgets/List/ListLove.vue";
import TableOrder from "../../components/Widgets/Table/TableOrder.vue";
import TablePlanner from "../../components/Widgets/Table/TablePlanner.vue";
import TablePlain from "../../components/Widgets/Table/TablePlain.vue";
import TableBrowser from "../../components/Widgets/Table/TableBrowser.vue";
import ChartAreaapex from "../../components/Widgets/Charts/ChartAreaapex.vue";
import ChartAreaapex2 from "../../components/Widgets/Charts/ChartAreaapex2.vue";
import TableApex from "../../components/Widgets/Table/TableApex.vue";
import ChartLineapex from "../../components/Widgets/Charts/ChartLineapex.vue";
import ChartBarecharts from "../../components/Widgets/Charts/ChartBarecharts.vue";
import ChartBarapex from "../../components/Widgets/Charts/ChartBarapex.vue";
import ChartMixapex from "../../components/Widgets/Charts/ChartMixapex.vue";
import PieCard from "../../components/Widgets/Charts/PieCard";
import ChartPieapex from "../../components/Widgets/Charts/ChartPieapex.vue";
import ChartCanvas from "../../components/Widgets/Charts/ChartCanvas.vue";
import AnalyticApexcharts from "../../components/Widgets/Analytic/AnalyticApexcharts.vue";
import AnalyticSparkline from "../../components/Widgets/Analytic/AnalyticSparkline.vue";
import AnalyticInfo from "../../components/Widgets/Analytic/AnalyticInfo.vue";
import AnalyticMix from "../../components/Widgets/Analytic/AnalyticMix.vue";
import AnalyticProgress from "../../components/Widgets/Analytic/AnalyticProgress.vue";

export default {
  components: {
    BaseCard,
    BaseHeader,
    ListFriends,
    ListFavorite,
    ListMessages,
    ListNotification,
    ListLove,
    TableOrder,
    TablePlanner,
    ChartAreaapex,
    ChartLineapex,
    ChartMixapex,
    ChartPieapex,
    AnalyticApexcharts,
    AnalyticSparkline,
    AnalyticInfo,
    AnalyticMix,
    AnalyticProgress,
    ChartBarapex,
    TablePlain,
    PieCard,
    TableBrowser,
    ChartBarecharts,
    ChartAreaapex2,
    ChartCanvas,
    TableApex
  },
  data() {
    return {
      items: [
        {
          avatar: "https://cdn.vuetifyjs.com/images/lists/1.jpg",
          title: "Brunch this weekend?",
          subtitle:
            "<span class='text--primary'>Ali Connors</span> &mdash; I'll be in your neighborhood doing errands this weekend. Do you want to hang out?"
        },
        {
          divider: true,
          inset: true
        },
        {
          avatar: "https://cdn.vuetifyjs.com/images/lists/2.jpg",
          title: 'Summer BBQ <span class="grey--text text--lighten-1">4</span>',
          subtitle:
            "<span class='text--primary'>to Alex, Scott, Jennifer</span> &mdash; Wish I could come, but I'm out of town this weekend."
        },
        {
          divider: true,
          inset: true
        },
        {
          avatar: "https://cdn.vuetifyjs.com/images/lists/3.jpg",
          title: "Oui oui",
          subtitle:
            "<span class='text--primary'>Sandra Adams</span> &mdash; Do you have Paris recommendations? Have you ever been?"
        },
        {
          divider: true,
          inset: true
        },
        {
          avatar: "https://cdn.vuetifyjs.com/images/lists/4.jpg",
          title: "Birthday gift",
          subtitle:
            "<span class='text--primary'>Trevor Hansen</span> &mdash; Have any ideas about what we should get Heidi for her birthday?"
        },
        {
          divider: true,
          inset: true
        },
        {
          avatar: "https://cdn.vuetifyjs.com/images/lists/5.jpg",
          title: "Recipe to try",
          subtitle:
            "<span class='text--primary'>Britta Holt</span> &mdash; We should eat this: Grate, Squash, Corn, and tomatillo Tacos."
        }
      ],
      valueDeterminate: 50,
      labels: ["SU", "MO", "TU", "WED", "TH", "FR", "SA"],
      time: 0,
      forecast: [
        {
          day: "Tuesday",
          icon: "mdi-white-balance-sunny",
          temp: "24\xB0/12\xB0"
        },
        {
          day: "Wednesday",
          icon: "mdi-white-balance-sunny",
          temp: "22\xB0/14\xB0"
        },
        {
          day: "Thursday",
          icon: "mdi-cloud",
          temp: "25\xB0/15\xB0"
        },
        {
          day: "Thursday",
          icon: "mdi-cloud",
          temp: "25\xB0/15\xB0"
        }
      ]
    };
  },
  mounted() {
    var options = {
      chart: {
        height: 300,
        type: "area",
        sparkline: {
          enabled: true
        }
      },
      series: [
        {
          name: "",
          data: [45, 52, 38, 45, 19, 23, 2]
        }
      ],
      colors: ["#ec2024"],
      opacity: 1,
      type: "solid",
      fill: {
        colors: ["#f06022"],
        type: "gradient",
        gradient: {
          shade: "dark",
          type: "vertical",
          shadeIntensity: 1,
          opacityFrom: 1,
          opacityTo: 1,
          gradientToColors: ["#ec2024"],
          stops: [50, 100]
        }
      },
      tooltip: {
        fixed: {
          enabled: true
        }
      },
      yaxis: {
        labels: {
          show: true,
          offsetX: 0,
          offsetY: 0,
          rotate: 0,
          formatter: function(val) {
            return val + " V";
          }
        }
      },
      xaxis: {
        crosshairs: {
          width: 1
        },
        categories: [
          "01 Jan",
          "02 Jan",
          "03 Jan",
          "04 Jan",
          "05 Jan",
          "06 Jan",
          "07 Jan"
        ]
      }
    };

    var chart = new ApexCharts(document.querySelector("#chart1"), options);

    chart.render();
    var options = {
      chart: {
        height: 300,
        type: "area",
        sparkline: {
          enabled: true
        }
      },
      series: [
        {
          name: "",
          data: [45, 52, 38, 45, 19, 23, 2]
        }
      ],
      colors: ["#9e0c88"],
      opacity: 1,
      type: "solid",
      fill: {
        colors: ["#b558ce"],
        type: "gradient",
        gradient: {
          shade: "dark",
          type: "vertical",
          shadeIntensity: 1,
          opacityFrom: 1,
          opacityTo: 1,
          gradientToColors: ["#ec2024"],
          stops: [50, 100]
        }
      },
      tooltip: {
        fixed: {
          enabled: true
        }
      },
      yaxis: {
        labels: {
          show: true,
          offsetX: 0,
          offsetY: 0,
          rotate: 0,
          formatter: function(val) {
            return val + " V";
          }
        }
      },
      xaxis: {
        crosshairs: {
          width: 1
        },
        categories: [
          "01 Jan",
          "02 Jan",
          "03 Jan",
          "04 Jan",
          "05 Jan",
          "06 Jan",
          "07 Jan"
        ]
      }
    };

    var chart = new ApexCharts(document.querySelector("#chart2"), options);

    chart.render();

    var options = {
      chart: {
        height: 300,
        type: "area",
        sparkline: {
          enabled: true
        }
      },
      series: [
        {
          name: "",
          data: [45, 52, 38, 45, 19, 23, 2]
        }
      ],
      colors: ["#114f8d"],
      opacity: 1,
      type: "solid",
      fill: {
        colors: ["#114f8d"],
        type: "gradient",
        gradient: {
          shade: "dark",
          type: "vertical",
          shadeIntensity: 1,
          opacityFrom: 1,
          opacityTo: 1,
          gradientToColors: ["#aad1f8"],
          stops: [50, 100]
        }
      },
      tooltip: {
        fixed: {
          enabled: true
        }
      },
      yaxis: {
        labels: {
          show: true,
          offsetX: 0,
          offsetY: 0,
          rotate: 0,
          formatter: function(val) {
            return val + " V";
          }
        }
      },
      xaxis: {
        crosshairs: {
          width: 1
        },
        categories: [
          "01 Jan",
          "02 Jan",
          "03 Jan",
          "04 Jan",
          "05 Jan",
          "06 Jan",
          "07 Jan"
        ]
      }
    };

    var chart = new ApexCharts(document.querySelector("#chart3"), options);

    chart.render();
  }
};
</script>
<style scoped>
.apexcharts-yaxis-annotation-label--invisible {
  display: none;
}

#chart {
  max-width: 270px;

  opacity: 1;
}
</style>
<!--====  End of DASHBOARD1  ====-->
